import {
    CREATE_UPDT_REVISION_FAIL,
    CREATE_UPDT_REVISION_SUCCESS,
    CREATE_REVISION_START,
    CREATE_UPDT_REVISION_PHASE_CHG,
    UPDATE_REVISION_START,
    ADD_TIMEOUT_PAYLOAD,
    UPDATE_TIMEOUT_STATUS,
    TAGS_PROG_BAR_STATUS,
    CREATE_DUPLICATELINE_START,
    CREATE_DUPLICATELINE_SUCCESS,
    CREATE_DUPLICATELINE_FAIL
} from './revTypes';

export const createdReviStartAct = (payload) => (
    {
        type: CREATE_REVISION_START,
        payload,
    }
)

export const createUpdtReviSuccAct = (payload) => (
    {
        type: CREATE_UPDT_REVISION_SUCCESS,
        payload,
    }
)



export const createUpdtReviFailAct = (payload) => (
    {
        type: CREATE_UPDT_REVISION_FAIL,
        payload,
    }
)

export const createUpdtReviPhaseAct = (payload) => (
    {
        type: CREATE_UPDT_REVISION_PHASE_CHG,
        payload
    }
)

export const updateReviStartAct = (payload) => (
    {
        type: UPDATE_REVISION_START,
        payload,
    }
)

export const addTimeOutPayloadAct = (payload) => (
    {
        type: ADD_TIMEOUT_PAYLOAD,
        payload,
    }
)

export const updtTimeOutStatusAct = (payload) => (
    {
        type: UPDATE_TIMEOUT_STATUS,
        payload,
    }
)

export const updtTagPBarStatusAct = (payload) => (
    {
        type: TAGS_PROG_BAR_STATUS,
        payload,
    }
)
export const createDuplicateLine = (payload) => (
    {
        type: CREATE_DUPLICATELINE_START,
        payload,
    }
)
export const createDuplicateLineSucc = (payload) => (
    {
        type: CREATE_DUPLICATELINE_SUCCESS,
        payload,
    }
)
export const createDuplicateLineFail = (payload) => (
    {
        type: CREATE_DUPLICATELINE_FAIL,
        payload,
    }
)







